import { PluggableStorage } from './PluggableStorage';

const STORAGE_KEY = 'session';

interface WeaveSession {
  id: string;
  startTime: number;
}

let storage: PluggableStorage | null = null;

function getStorage(): PluggableStorage {
  if (!storage) {
    storage = PluggableStorage.create('weave');
  }
  return storage;
}

function getSession(): WeaveSession | null {
  return getStorage().getItem<WeaveSession>(STORAGE_KEY);
}

export function startWeaveSession() {
  try {
    if (getSession() != null) return;
    getStorage().setItem(STORAGE_KEY, { id: crypto.randomUUID(), startTime: Date.now() });
  } catch (e) {
    console.error('weave session error', e);
  }
}

export function getWeaveSessionId(): string | null {
  try {
    return getSession()?.id ?? null;
  } catch (e) {
    console.error('weave session error', e);
    return null;
  }
}

export function getWeaveSessionLength(): number | null {
  try {
    const session = getSession();
    if (!session) return null;
    return Date.now() - session.startTime;
  } catch (e) {
    console.error('weave session error', e);
    return null;
  }
}

export function deleteWeaveSessionId(): void {
  try {
    getStorage().removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('weave session error', e);
  }
}
